module.exports = __webpack_public_path__ + "static/img/color.154890c6.png";